import { Link } from 'react-router-dom';
import { APP_NAME, APP_LOGO_SRC, APP_LOGO_ALT } from '../../config/branding.js';
import { defaultRoute } from '../../config/menuData.js';

/**
 * The layout shells' brand slot:
 *
 *   <a class="navbar-brand" href="#">PropStudioOS</a>
 *
 * The placeholder `href="#"` becomes a router link to the design's
 * DefaultMenuItem. The application name and the (currently absent) logo come
 * from src/config/branding.js, so branding is declared once for every layout.
 */
export default function AppBrand({ className = 'navbar-brand' }) {
  return (
    <Link className={className} to={defaultRoute()}>
      {APP_LOGO_SRC ? (
        <img className="header-logo" src={APP_LOGO_SRC} alt={APP_LOGO_ALT} />
      ) : (
        <span className="app-brand__name">{APP_NAME}</span>
      )}
    </Link>
  );
}
